import { memo } from 'react';

import InputAdornment from '@material-ui/core/InputAdornment';
import CheckIcon from '@material-ui/icons/Check';

import { useStyles } from './CheckAdornment.styles';

/**
 * @component CheckAdornment
 * @private
 * @description Internal component that displays a check icon as an adornment
 */
export const CheckAdornment = memo(() => {
  const styles = useStyles();

  return (
    <InputAdornment position="end" className={styles.checkAdornment}>
      <CheckIcon />
    </InputAdornment>
  );
});

CheckAdornment.displayName = 'CheckAdornment';
